import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Tesseract from "tesseract.js";
const AddJobCard = () => {
  const server_url = localStorage.getItem("server_url");
  const grage_id = localStorage.getItem("grage_id");
  const state_id = localStorage.getItem("state_id");
  const city_id = localStorage.getItem("city_id");
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const navigate = useNavigate();
  const location = useLocation();
  const [vehicleRegNo, setVehicleRegNo] = useState("");
  const [vehicle, setVehicle] = useState(null);
  const [loading, setLoading] = useState(false);
  // Camera states
  const [showCamera, setShowCamera] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  const [ocrLoading, setOcrLoading] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  // Simplified flow control
  const [flowState, setFlowState] = useState("SEARCH"); // SEARCH, ADD_CUSTOMER, SERVICE
  // Customer Data
  const [customerData, setCustomerData] = useState({
    customer_name: "",
    customer_mobile: "",
    customer_email: "",
    customer_area: "",
    customer_address: "",
    state_id: state_id || "",
    city_id: city_id || "",
    customer_pincode: "",
    customer_company_name: "",
  });
  // Service Data
  const [serviceData, setServiceData] = useState({
    vehicle_entry_remark: "",
    items: [],
  });
  const [showItemModal, setShowItemModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [currentItem, setCurrentItem] = useState({
    description: "",
    qty: "",
    rate: "",
    gst: "0",
    amount: "",
  });
  const [lastGST, setLastGST] = useState("0");
  const [editingIndex, setEditingIndex] = useState(null); // Track which item is being edited
  // Suggestion states
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestionLoading, setSuggestionLoading] = useState(false);
  // Debounce timer
  const [debounceTimer, setDebounceTimer] = useState(null);
  // NEW: States for multiple vehicles popup
  const [multipleVehicles, setMultipleVehicles] = useState([]);
  const [showVehiclePopup, setShowVehiclePopup] = useState(false);
  const [autoSearchTimer, setAutoSearchTimer] = useState(null);
  useEffect(() => {
    if (location.state?.vehicle) {
      const veh = location.state.vehicle;
      setVehicle(veh);
      setVehicleRegNo(veh.vehicle_reg_no || "");
      setFlowState("SERVICE");
    }
  }, [location.state]);
  // Cleanup timers on unmount
  useEffect(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      if (autoSearchTimer) {
        clearTimeout(autoSearchTimer);
      }
    };
  }, [debounceTimer, autoSearchTimer]);
  // ==================== CAMERA FUNCTIONS ====================
  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" }, // Back camera
      });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        streamRef.current = stream;
      }
    } catch (err) {
      toast.error("Camera access denied");
      setShowCamera(false);
    }
  };
  const capturePhoto = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0);
    const imageDataUrl = canvas.toDataURL("image/jpeg");
    setCapturedImage(imageDataUrl);
  };
  const processImageWithOCR = async () => {
    if (!capturedImage) return;
    setOcrLoading(true);
    try {
      const result = await Tesseract.recognize(capturedImage, "eng", {
        logger: (m) => console.log(m),
        tessedit_char_whitelist: "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789- ",
      });
      let text = result.data.text.toUpperCase();
      // Enhanced Indian plate regex patterns
      const platePatterns = [
        /[A-Z]{2}[-\s]?[0-9]{1,2}[-\s]?[A-Z]{1,2}[-\s]?[0-9]{4}/g, // MH-12-AB-1234
        /[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{4}/g, // MH12AB1234
        /[A-Z]{2}[0-9]{4,}/g, // MH123456
        /[0-9]{1,2}[A-Z]{1,3}[0-9]{4}/g, // 12ABC1234
      ];
      let detectedPlate = "";
      // Try each pattern
      for (const pattern of platePatterns) {
        const matches = text.match(pattern);
        if (matches && matches.length > 0) {
          detectedPlate = matches[0]
            .replace(/[^A-Z0-9]/g, "") // Clean it
            .slice(0, 10); // Max 10 chars
          break;
        }
      }
      // If no pattern matches, extract alphanumeric string
      if (!detectedPlate) {
        const alphanumeric = text.replace(/[^A-Z0-9]/g, "");
        if (alphanumeric.length >= 5 && alphanumeric.length <= 10) {
          detectedPlate = alphanumeric;
        }
      }
      if (detectedPlate.length >= 5) {
        setVehicleRegNo(detectedPlate);
        toast.success(`Plate detected: ${detectedPlate}`);
        closeCamera();
        // Trigger search after a short delay
        setTimeout(() => {
          handleAutoSearch();
        }, 500);
      } else {
        toast.error("Could not read plate clearly. Try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("OCR failed. Try taking a clearer photo.");
    } finally {
      setOcrLoading(false);
    }
  };
  const closeCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
    }
    setShowCamera(false);
    setCapturedImage(null);
  };
  // Start camera when modal opens
  useEffect(() => {
    if (showCamera) {
      startCamera();
    }
    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop());
      }
    };
  }, [showCamera]);
  // ==================== END CAMERA FUNCTIONS ====================
  // Auto search when plate number reaches 10 characters
  useEffect(() => {
    const plateNo = vehicleRegNo.replace(/\s/g, "");

    if (plateNo.length === 10) {
      // Clear any existing timer
      if (autoSearchTimer) {
        clearTimeout(autoSearchTimer);
      }

      // Set a small delay to allow user to finish typing
      const timer = setTimeout(() => {
        handleAutoSearch();
      }, 300);

      setAutoSearchTimer(timer);
    }

    return () => {
      if (autoSearchTimer) {
        clearTimeout(autoSearchTimer);
      }
    };
  }, [vehicleRegNo]);
  // Calculate amount when qty, rate or gst changes
  useEffect(() => {
    const qty = parseFloat(currentItem.qty) || 0;
    const rate = parseFloat(currentItem.rate) || 0;
    const gst = parseFloat(currentItem.gst) || 0;
    const baseAmount = qty * rate;
    const gstAmount = (baseAmount * gst) / 100;
    const totalAmount = baseAmount + gstAmount;
    setCurrentItem((prev) => ({
      ...prev,
      amount: totalAmount.toFixed(2),
    }));
  }, [currentItem.qty, currentItem.rate, currentItem.gst]);
  // Auto-fill customer data when vehicle is found
  useEffect(() => {
    if (vehicle) {
      setCustomerData((prev) => ({
        ...prev,
        customer_name: vehicle.customer_name || "",
        customer_mobile: vehicle.customer_mobile || "",
      }));
    }
  }, [vehicle]);
  // NEW: Auto search function
  const handleAutoSearch = async () => {
    if (!vehicleRegNo.trim()) {
      return;
    }
    setLoading(true);
    try {
      const formDataSearch = new FormData();
      formDataSearch.append("company_id", "2");
      formDataSearch.append("customer_id", "");
      formDataSearch.append("vehicle_grage_id", grage_id);
      formDataSearch.append("vehicle_reg_no", vehicleRegNo);
      const response = await axios.post(
        `${server_url}vehicle.php`,
        formDataSearch,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.data.status == "1") {
        const vehicles = response.data.result;

        if (vehicles.length === 1) {
          // Single vehicle found
          const foundVehicle = vehicles[0];
          setVehicle(foundVehicle);
          setFlowState("SERVICE");
          toast.success("Vehicle found! Please proceed with service details.");
        } else if (vehicles.length > 1) {
          // Multiple vehicles found - show popup
          setMultipleVehicles(vehicles);
          setShowVehiclePopup(true);
        } else {
          // No vehicles found
          setVehicle(null);
          setFlowState("ADD_CUSTOMER");
          toast("Vehicle not found. Please add customer details.", {
            icon: "ℹ️",
          });
        }
      } else {
        // No vehicles found
        setVehicle(null);
        setFlowState("ADD_CUSTOMER");
        toast("Vehicle not found. Please add customer details.", {
          icon: "ℹ️",
        });
      }
    } catch (error) {
      console.error("Auto search vehicle error:", error);
      toast.error("Unable to search vehicle. Please try again.");
      setVehicle(null);
      setFlowState("SEARCH");
    } finally {
      setLoading(false);
    }
  };
  const handleSearchVehicle = async (e) => {
    if (e) e.preventDefault();
    if (!vehicleRegNo.trim()) {
      toast.error("Please enter vehicle plate number");
      return;
    }
    setLoading(true);
    try {
      const formDataSearch = new FormData();
      formDataSearch.append("company_id", "2");
      formDataSearch.append("customer_id", "");
      formDataSearch.append("vehicle_grage_id", grage_id);
      formDataSearch.append("vehicle_reg_no", vehicleRegNo);
      const response = await axios.post(
        `${server_url}vehicle.php`,
        formDataSearch,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.data.status == "1") {
        const vehicles = response.data.result;

        if (vehicles.length === 1) {
          // Single vehicle found
          const foundVehicle = vehicles[0];
          setVehicle(foundVehicle);
          setFlowState("SERVICE");
          toast.success("Vehicle found! Please proceed with service details.");
        } else if (vehicles.length > 1) {
          // Multiple vehicles found - show popup
          setMultipleVehicles(vehicles);
          setShowVehiclePopup(true);
        } else {
          // No vehicles found
          setVehicle(null);
          setFlowState("ADD_CUSTOMER");
          toast("Vehicle not found. Please add customer details.", {
            icon: "ℹ️",
          });
        }
      } else {
        // No vehicles found
        setVehicle(null);
        setFlowState("ADD_CUSTOMER");
        toast("Vehicle not found. Please add customer details.", {
          icon: "ℹ️",
        });
      }
    } catch (error) {
      console.error("Search vehicle error:", error);
      toast.error("Unable to search vehicle. Please try again.");
      setVehicle(null);
      setFlowState("SEARCH");
    } finally {
      setLoading(false);
    }
  };
  // NEW: Handle vehicle selection from popup
  const handleVehicleSelect = (selectedVehicle) => {
    setVehicle(selectedVehicle);
    setShowVehiclePopup(false);
    setMultipleVehicles([]);
    setFlowState("SERVICE");
    toast.success("Vehicle selected! Please proceed with service details.");
  };
  const handleAddCustomerAndVehicle = async (e) => {
    e.preventDefault();
    if (
      !customerData.customer_name ||
      !customerData.customer_mobile ||
      !vehicleRegNo.trim()
    ) {
      toast.error("Please fill customer name, mobile and vehicle number");
      return;
    }
    setLoading(true);
    try {
      // First, add customer
      const customerPostData = new FormData();
      customerPostData.append("company_id", "2");
      customerPostData.append("customer_grage_id", grage_id);
      customerPostData.append("customer_name", customerData.customer_name);
      customerPostData.append("customer_mobile", customerData.customer_mobile);
      customerPostData.append(
        "customer_email",
        customerData.customer_email || ""
      );
      customerPostData.append(
        "customer_area",
        customerData.customer_area || ""
      );
      customerPostData.append(
        "customer_address",
        customerData.customer_address || ""
      );
      customerPostData.append("state_id", state_id);
      customerPostData.append("city_id", city_id);
      customerPostData.append(
        "customer_pincode",
        customerData.customer_pincode || ""
      );
      customerPostData.append(
        "customer_company_name",
        customerData.customer_company_name || ""
      );
      const customerResponse = await axios.post(
        `${server_url}add_customer.php`,
        customerPostData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (customerResponse.data.status == "1") {
        // Then, add vehicle with just plate number
        const vehiclePostData = new FormData();
        vehiclePostData.append("company_id", "2");
        vehiclePostData.append("vehicle_grage_id", grage_id);
        vehiclePostData.append(
          "customer_id",
          customerResponse.data.customer_id
        );
        vehiclePostData.append("vehicle_reg_name", customerData.customer_name);
        vehiclePostData.append("vehicle_reg_no", vehicleRegNo.trim());
        vehiclePostData.append("brand_id", "");
        vehiclePostData.append("model_id", "");
        vehiclePostData.append("sub_model_id", "");
        vehiclePostData.append("vehicle_type_id", "");
        vehiclePostData.append("fuel_type_id", "");
        vehiclePostData.append("vehicle_reg_date", "");
        vehiclePostData.append("vehicle_reg_valid_till", "");
        vehiclePostData.append("vehicle_engine_no", "");
        vehiclePostData.append("vehicle_chassis_no", "");
        vehiclePostData.append("vehicle_colour_name", "");
        vehiclePostData.append("vehicle_tyre_size", "");
        vehiclePostData.append("vehicle_battery_type", "");
        vehiclePostData.append("vehicle_puc_start_date", "");
        vehiclePostData.append("vehicle_puc_end_date", "");
        vehiclePostData.append("vehicle_cng_start_date", "");
        vehiclePostData.append("vehicle_cng_end_date", "");
        const vehicleResponse = await axios.post(
          `${server_url}add_vehicle.php`,
          vehiclePostData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (vehicleResponse.data.status == "1") {
          const newVehicle = vehicleResponse.data.vehicle || {
            vehicle_id: vehicleResponse.data.vehicle_id,
            customer_id: customerResponse.data.customer_id,
            customer_name: customerData.customer_name,
            customer_mobile: customerData.customer_mobile,
            vehicle_reg_no: vehicleRegNo.trim(),
            brand_name: "",
            model_name: "",
          };
          setVehicle(newVehicle);
          setFlowState("SERVICE");
          toast.success(
            "Customer and vehicle added successfully! Now add service details."
          );
        } else {
          toast.error(vehicleResponse.data.error || "Failed to add vehicle.");
        }
      } else {
        toast.error(customerResponse.data.error || "Failed to add customer.");
      }
    } catch (error) {
      console.error("Add customer and vehicle error:", error);
      toast.error("Unable to add customer and vehicle. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  // Debounced API call function
  const fetchSuggestions = useCallback(
    async (value) => {
      if (!value || value.length < 3) {
        setSuggestions([]);
        setShowSuggestions(false);
        setSuggestionLoading(false);
        return;
      }
      setSuggestionLoading(true);
      try {
        const formData = new FormData();
        formData.append("text", value);
        formData.append("garage_id", grage_id);
        const response = await axios.post(
          `${server_url}search_items.php`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        const res = response.data;
        if (res.status === "1" && res.result) {
          setSuggestions(res.result);
          setShowSuggestions(res.result.length > 0);
        } else {
          setSuggestions([]);
          setShowSuggestions(false);
        }
      } catch (error) {
        console.error("Search suggestions error:", error);
        setSuggestions([]);
        setShowSuggestions(false);
      } finally {
        setSuggestionLoading(false);
      }
    },
    [server_url, grage_id]
  );
  // Handle description change with debounce
  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    setCurrentItem({ ...currentItem, description: value });
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    const timer = setTimeout(() => {
      fetchSuggestions(value);
    }, 300); // 300ms debounce
    setDebounceTimer(timer);
  };
  // Handle suggestion selection
  const handleSuggestionSelect = (suggestion) => {
    setCurrentItem({
      ...currentItem,
      description: suggestion.vehicle_entry_detail_description,
    });
    setSuggestions([]);
    setShowSuggestions(false);
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
  };
  const handleAddItem = () => {
    setCurrentItem({
      description: "",
      qty: "",
      rate: "",
      gst: lastGST,
      amount: "",
    });
    setEditingIndex(null);
    setSuggestions([]);
    setShowSuggestions(false);
    setShowItemModal(true);
  };
  // ADD THIS FUNCTION - Same like add popup
  const openEditItem = (item, index) => {
    setCurrentItem({
      description: item.description,
      qty: item.qty,
      rate: item.rate,
      gst: item.gst,
      amount: item.amount,
    });
    setEditingIndex(index);
    setSuggestions([]);
    setShowSuggestions(false);
    setShowItemModal(true);
  };
  const handleSubmitItem = () => {
    if (!currentItem.description || !currentItem.qty || !currentItem.rate) {
      toast.error("Please fill description, quantity and rate");
      return;
    }
    if (editingIndex !== null) {
      // Update existing item
      setServiceData((prev) => ({
        ...prev,
        items: prev.items.map((item, index) =>
          index === editingIndex ? { ...currentItem, id: item.id } : item
        ),
      }));
      toast.success("Item updated successfully!");
    } else {
      // Add new item
      setServiceData((prev) => ({
        ...prev,
        items: [...prev.items, { ...currentItem, id: Date.now() }],
      }));
      toast.success("Item added successfully!");
    }
    setLastGST(currentItem.gst);
    setShowItemModal(false);
    setEditingIndex(null);
  };
  const confirmRemoveItem = (index) => {
    setItemToDelete(index);
    setShowDeleteConfirm(true);
  };
  const removeItem = () => {
    if (itemToDelete !== null) {
      setServiceData((prev) => ({
        ...prev,
        items: prev.items.filter((_, i) => i !== itemToDelete),
      }));
      toast.success("Item removed successfully!");
    }
    setShowDeleteConfirm(false);
    setItemToDelete(null);
  };
  const calculateTotals = () => {
    let totalRate = 0;
    let totalGST = 0;
    let totalAmount = 0;
    serviceData.items.forEach((item) => {
      const rate = parseFloat(item.rate) || 0;
      const qty = parseFloat(item.qty) || 0;
      const gst = parseFloat(item.gst) || 0;
      const amount = parseFloat(item.amount) || 0;
      totalRate += rate * qty;
      totalGST += (rate * qty * gst) / 100;
      totalAmount += amount;
    });
    return {
      totalRate: totalRate.toFixed(2),
      totalGST: totalGST.toFixed(2),
      totalAmount: totalAmount.toFixed(2),
    };
  };
  const handleStartService = async (e) => {
    e.preventDefault();
    if (!vehicle || !vehicle.vehicle_id) {
      toast.error("Vehicle not found.");
      return;
    }
    if (serviceData.items.length == 0) {
      toast.error("Please add at least one service item");
      return;
    }
    setLoading(true);
    try {
      const totals = calculateTotals();
      const postData = new FormData();
      postData.append("company_id", "2");
      postData.append("customer_id", vehicle.customer_id || "");
      postData.append("vehicle_id", vehicle.vehicle_id);
      postData.append("vehicle_entry_grage_id", grage_id);
      postData.append("vehicle_entry_total_amt", totals.totalAmount);
      postData.append("vehicle_entry_remark", serviceData.vehicle_entry_remark);
      // Add arrays for items
      serviceData.items.forEach((item) => {
        postData.append("vehicle_entry_detail_description[]", item.description);
        postData.append("vehicle_entry_detail_qty[]", item.qty);
        postData.append("vehicle_entry_detail_rate[]", item.rate);
        postData.append("vehicle_entry_detail_gst[]", item.gst);
        postData.append("vehicle_entry_detail_amt[]", item.amount);
      });
      const response = await axios.post(
        `${server_url}vehicle_in.php`,
        postData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.data.status == "1") {
        toast.success("Service started successfully!");
        navigate("/");
      } else {
        toast.error(response.data.error || "Failed to start service.");
      }
    } catch (error) {
      console.error("Start service error:", error);
      toast.error("Unable to start service. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const resetForm = () => {
    setVehicleRegNo("");
    setVehicle(null);
    setFlowState("SEARCH");
    setServiceData({
      vehicle_entry_remark: "",
      items: [],
    });
    setCustomerData({
      customer_name: "",
      customer_mobile: "",
      customer_email: "",
      customer_area: "",
      customer_address: "",
      state_id: state_id || "",
      city_id: city_id || "",
      customer_pincode: "",
      customer_company_name: "",
    });
    setMultipleVehicles([]);
    setShowVehiclePopup(false);
  };
  const totals = calculateTotals();
  return (
    <div className="mobile-responsive-content">
      <div className="content-wrap add-job-card-page">
        {/* Search Section - Always Visible */}
        <div className="home-icon">
          <div className="section-home">
            <form onSubmit={handleSearchVehicle} className="search-form">
              <div className="input-group same-line">
                <input
                  type="text"
                  placeholder="Enter Plate Number"
                  value={vehicleRegNo}
                  onChange={(e) => {
                    const value = e.target.value.toUpperCase();
                    // Remove spaces and special characters, allow only alphanumeric
                    const cleanValue = value.replace(/[^A-Z0-9]/g, "");
                    setVehicleRegNo(cleanValue);
                  }}
                  className="search-input"
                  maxLength={10}
                  disabled={flowState !== "SEARCH"}
                />
                {flowState !== "SEARCH" ? (
                  <button
                    onClick={resetForm}
                    className="reset-btn"
                    type="button"
                  >
                    ✕
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="search-btn"
                    disabled={loading}
                  >
                    {loading ? "Searching..." : "Search"}
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
        {/* Floating Camera Button - Only in SEARCH mode */}
        {flowState === "SEARCH" && (
          <button
          className="jobcardcamera"
            onClick={() => setShowCamera(true)}
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              background: "#4299e1",
              color: "white",
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              fontSize: "28px",
              border: "none",
              boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
              zIndex: 999,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            📷
          </button>
        )}
        {/* Camera Modal */}
        {showCamera && (
          <div className="modal-overlay" style={{ zIndex: 1001 }}>
            <div
              className="modal-content"
              style={{ padding: 0, maxWidth: "95%", height: "90vh" }}
            >
              <div className="modal-header">
                <h3>Capture Number Plate</h3>
                <button onClick={() => closeCamera()} className="close-btn">
                  X
                </button>
              </div>
              <div
                style={{
                  position: "relative",
                  height: "70vh",
                  background: "#000",
                }}
              >
                {!capturedImage ? (
                  <>
                    <video
                      ref={videoRef}
                      autoPlay
                      playsInline
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        border: "3px solid rgba(66, 153, 225, 0.7)",
                        width: "80%",
                        height: "120px",
                        borderRadius: "12px",
                        pointerEvents: "none",
                      }}
                    />
                  </>
                ) : (
                  <img
                    src={capturedImage}
                    alt="Captured"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                )}
              </div>
              <div className="modal-footer" style={{ padding: 15 }}>
                {!capturedImage ? (
                  <button
                    onClick={capturePhoto}
                    style={{
                      background: "#48bb78",
                      color: "white",
                      padding: "16px",
                      borderRadius: "50%",
                      width: "60px",
                      height: "60px",
                      fontSize: "30px",
                      border: "none",
                    }}
                  >
                    📸
                  </button>
                ) : (
                  <>
                    <button
                      onClick={() => setCapturedImage(null)}
                      className="btn-secondary"
                    >
                      Retake
                    </button>
                    <button
                      onClick={processImageWithOCR}
                      className="btn-primary"
                      disabled={ocrLoading}
                    >
                      {ocrLoading ? "Reading Plate..." : "Read Plate"}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        {/* Hidden Canvas for Capture */}
        <canvas ref={canvasRef} style={{ display: "none" }} />
        {/* Multiple Vehicles Popup */}
        {showVehiclePopup && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h3>Select Vehicle</h3>
                <button
                  onClick={() => setShowVehiclePopup(false)}
                  className="close-btn"
                >
                  ✕
                </button>
              </div>

              <div className="modal-body">
                <p className="popup-description">
                  Multiple vehicles found for plate number:{" "}
                  <strong>{vehicleRegNo}</strong>
                </p>

                <div className="vehicles-list">
                  {multipleVehicles.map((veh, index) => (
                    <div
                      key={index}
                      className="vehicle-item"
                      onClick={() => handleVehicleSelect(veh)}
                    >
                      <div className="vehicle-info">
                        <div className="vehicle-main">
                          <span className="vehicle-name">
                            {veh.customer_name}
                          </span>
                          <span className="vehicle-mobile">
                            {veh.customer_mobile}
                          </span>
                        </div>
                        <div className="vehicle-details">
                          {veh.vehicle_reg_no && (
                            <span className="type">{veh.vehicle_reg_no}</span>
                          )}
                          {veh.brand_name && (
                            <span className="brand">{veh.brand_name}</span>
                          )}
                          {veh.model_name && (
                            <span className="model">{veh.model_name}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  onClick={() => {
                    setShowVehiclePopup(false);
                    setMultipleVehicles([]);
                    setFlowState("ADD_CUSTOMER");
                  }}
                  className="btn-secondary full-width"
                  style={{ margin: "10px 0px" }}
                >
                  Add New Vehicle Instead
                </button>
              </div>
            </div>
          </div>
        )}
        {/* SCENARIO 1: Vehicle Not Found - Show Customer Form */}
        {flowState == "ADD_CUSTOMER" && (
          <div className="result-section" style={{ marginTop: "15px" }}>
            <div className="form-card">
              <div className="card-header">
                <i className="fas fa-user-plus"></i>
                <h3>Add New Customer</h3>
              </div>
              <form onSubmit={handleAddCustomerAndVehicle}>
                <div className="form-grid">
                  <div className="form-group">
                    <label className="required">Customer Name</label>
                    <input
                      type="text"
                      value={customerData.customer_name}
                      onChange={(e) =>
                        setCustomerData({
                          ...customerData,
                          customer_name: e.target.value,
                        })
                      }
                      placeholder="Enter customer name"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="required">Mobile</label>

                    <input
                      type="number"
                      value={customerData.customer_mobile}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Remove any non-digit characters
                        const digitsOnly = value.replace(/\D/g, "");
                        // Limit to 10 digits
                        if (digitsOnly.length <= 10) {
                          setCustomerData({
                            ...customerData,
                            customer_mobile: digitsOnly,
                          });
                        }
                      }}
                      placeholder="Enter 10-digit mobile number"
                      maxLength={10}
                      minLength={10}
                      required
                    />
                    <label>Note: Do not use +91 in mobile number</label>
                  </div>
                </div>
                <button
                  type="submit"
                  className="submit-btn primary"
                  disabled={loading}
                >
                  {loading ? "Adding..." : "Add Customer & Vehicle"}
                </button>
              </form>
            </div>
          </div>
        )}
        {/* SCENARIO 2: Vehicle Found - Show Customer Details */}
        {flowState == "SERVICE" && vehicle && (
          <div className="result-section" style={{ marginTop: "15px" }}>
            <div className="customer-card">
              <div className="card-header">
                <i className="fas fa-user-check"></i>
                <h3>Customer Details</h3>
              </div>
              <div className="customer-details">
                <div className="customer-info">
                  <div className="info-row">
                    <span className="label">Customer Name</span>
                    <span className="value">{vehicle.customer_name}</span>
                  </div>
                  <div className="info-row">
                    <span className="label">Mobile</span>
                    <span className="value">
                      <button
                        className="call-btn"
                        onClick={() =>
                          window.open(`tel:${vehicle.customer_mobile}`)
                        }
                      >
                        📞
                      </button>
                      {vehicle.customer_mobile}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="label">Vehicle Number</span>
                    <span className="value">{vehicle.vehicle_reg_no}</span>
                  </div>
                  {vehicle.brand_name && (
                    <div className="info-row">
                      <span className="label">Brand Name</span>
                      <span className="value">{vehicle.brand_name}</span>
                    </div>
                  )}
                  {vehicle.model_name && (
                    <div className="info-row">
                      <span className="label">Model Name</span>
                      <span className="value">{vehicle.model_name}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Service Section - Show for both scenarios */}
        {flowState == "SERVICE" && (
          <div className="result-section">
            <div className="form-card">
              <div className="card-header">
                <i className="fas fa-tools"></i>
                <h3>Service Details</h3>
              </div>
              {/* Add Item Button */}
              <button onClick={handleAddItem} className="add-item-btn">
                <i className="fas fa-plus"></i>
                Add Service Item
              </button>
              {/* Items List */}
              {serviceData.items.length > 0 && (
                <div className="items-list">
                  <h4>Items List</h4>
                  <table className="items-table" style={{ textAlign: "left" }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left" }}>Description</th>
                        <th style={{ textAlign: "center" }}>Qty</th>
                        <th style={{ textAlign: "right" }}>Rate</th>
                        <th style={{ textAlign: "right" }}>GST</th>
                        <th style={{ textAlign: "right" }}>Amount</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {serviceData.items.map((item, index) => (
                        <tr key={item.id}>
                          <td
                            onClick={() => openEditItem(item, index)}
                            style={{
                              textAlign: "left",
                              textDecoration: "underline",
                            }}
                          >
                            {item.description}
                          </td>
                          <td style={{ textAlign: "center" }}>{item.qty}</td>
                          <td style={{ textAlign: "right" }}>₹{item.rate}</td>
                          <td style={{ textAlign: "right" }}>{item.gst}%</td>
                          <td style={{ textAlign: "right" }}>₹{item.amount}</td>
                          <td style={{ display: "table-caption" }}>
                            <button
                              onClick={() => confirmRemoveItem(index)}
                              className="remove-btn"
                              title="Remove"
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {/* Summary */}
              {serviceData.items.length > 0 && (
                <div className="summary-card">
                  <h4>Summary</h4>
                  <div className="summary-row">
                    <span>Sub Total:</span>
                    <span>₹{totals.totalRate}</span>
                  </div>
                  <div className="summary-row">
                    <span>GST:</span>
                    <span>₹{totals.totalGST}</span>
                  </div>
                  <div className="summary-row total">
                    <span>Final Total:</span>
                    <span>₹{totals.totalAmount}</span>
                  </div>
                </div>
              )}
              {/* Remarks */}
              <div className="form-group full-width">
                <label>Remarks</label>
                <textarea
                  value={serviceData.vehicle_entry_remark}
                  onChange={(e) =>
                    setServiceData({
                      ...serviceData,
                      vehicle_entry_remark: e.target.value,
                    })
                  }
                  placeholder="Enter any remarks or notes"
                  rows="3"
                />
              </div>
              {/* Start Service Button */}
              <button
                onClick={handleStartService}
                className="submit-btn primary"
                disabled={serviceData.items.length == 0}
              >
                Create Job Card
              </button>
            </div>
          </div>
        )}
        {/* Add/Edit Item Modal */}
        {showItemModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h3>
                  {editingIndex !== null
                    ? "Edit Service Item"
                    : "Add Service Item"}
                </h3>
                <button
                  onClick={() => setShowItemModal(false)}
                  className="close-btn"
                >
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group description-group">
                  <label className="required">Description</label>
                  <input
                    type="text"
                    value={currentItem.description}
                    onChange={handleDescriptionChange}
                    onFocus={() => {
                      if (currentItem.description.length >= 3) {
                        fetchSuggestions(currentItem.description);
                      }
                    }}
                    onBlur={() =>
                      setTimeout(() => setShowSuggestions(false), 150)
                    }
                    placeholder="Enter item description"
                    autoComplete="off"
                  />
                  {suggestionLoading && (
                    <div className="suggestion-loading">
                      Loading suggestions...
                    </div>
                  )}
                  {showSuggestions && suggestions.length > 0 && (
                    <div className="suggestions-dropdown">
                      {suggestions.map((sug, idx) => (
                        <div
                          key={idx}
                          className="suggestion-item"
                          onClick={() => handleSuggestionSelect(sug)}
                        >
                          {sug.vehicle_entry_detail_description}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label className="required">Quantity</label>
                  <input
                    type="number"
                    value={currentItem.qty}
                    onChange={(e) =>
                      setCurrentItem({ ...currentItem, qty: e.target.value })
                    }
                    placeholder="Qty"
                    min="1"
                  />
                </div>
                <div className="form-group">
                  <label className="required">Rate</label>
                  <input
                    type="number"
                    value={currentItem.rate}
                    onChange={(e) =>
                      setCurrentItem({ ...currentItem, rate: e.target.value })
                    }
                    placeholder="Rate"
                    min="0"
                    step="0.01"
                  />
                </div>
                <div className="form-group">
                  <label>GST %</label>
                  <div className="gst-options">
                    {["0", "5", "18"].map((gst) => (
                      <label key={gst} className="radio-label">
                        <input
                          type="radio"
                          name="gst"
                          value={gst}
                          checked={currentItem.gst == gst}
                          onChange={(e) =>
                            setCurrentItem({
                              ...currentItem,
                              gst: e.target.value,
                            })
                          }
                        />
                        <span>{gst}%</span>
                      </label>
                    ))}
                  </div>
                </div>
                <div className="form-group">
                  <label>Amount</label>
                  <input
                    type="text"
                    value={`₹${currentItem.amount}`}
                    readOnly
                    className="amount-display"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  onClick={() => setShowItemModal(false)}
                  className="btn-secondary"
                >
                  Cancel
                </button>
                <button onClick={handleSubmitItem} className="btn-primary">
                  {editingIndex !== null ? "Update Item" : "Add Item"}
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Delete Confirmation Modal */}
        {showDeleteConfirm && (
          <div className="modal-overlay">
            <div className="modal-content delete-confirm-modal">
              <div className="modal-header">
                <h3>Confirm Delete</h3>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to remove this item?</p>
                <div className="delete-actions">
                  <button
                    onClick={() => setShowDeleteConfirm(false)}
                    className="btn-secondary"
                  >
                    Cancel
                  </button>
                  <button onClick={removeItem} className="btn-danger">
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <style jsx>{`
        .modal-header h3 {
          font-size: 1.25rem;
        }

        .search-note {
          font-size: 12px;
          color: #666;
          margin-top: 4px;
          text-align: center;
        }

        .popup-description {
          margin-bottom: 16px;
          color: #4a5568;
          text-align: center;
        }

        .vehicles-list {
          max-height: 300px;
          overflow-y: auto;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
        }

        .vehicle-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 16px;
          border-bottom: 1px solid #e2e8f0;
          cursor: pointer;
          transition: background-color 0.2s;
        }

        .vehicle-item:hover {
          background-color: #f7fafc;
        }

        .vehicle-item:last-child {
          border-bottom: none;
        }

        .vehicle-info {
          flex: 1;
        }

        .vehicle-main {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 4px;
        }

        .vehicle-name {
          font-weight: 600;
          color: #2d3748;
        }

        .vehicle-mobile {
          color: #4a5568;
          font-size: 14px;
        }

        .vehicle-details {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }

        .brand,
        .model,
        .type {
          background: #edf2f7;
          padding: 2px 8px;
          border-radius: 4px;
          font-size: 12px;
          color: #4a5568;
        }

        .select-arrow {
          color: #4299e1;
          font-size: 18px;
          font-weight: bold;
          margin-left: 12px;
        }

        .full-width {
          width: 100%;
        }
        .form-card {
          box-shadow: 3px 3px 20px 0px #00000036;
        }
        /* Customer Details Styles - No Table */
        .customer-info {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .info-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          border-bottom: 1px solid #f0f0f0;
        }
        .info-row:last-child {
          border-bottom: none;
        }
        .info-row .label {
          color: #718096;
          font-weight: 500;
          font-size: 14px;
        }
        .info-row .value {
          color: #2d3748;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        /* Items Table Styles - No Scroll */
        .items-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 14px;
          margin-bottom: 16px;
        }
        .items-table th {
          background: #0352a1;
          color: white;
          padding: 12px 8px;
          text-align: left;
          font-weight: 600;
          border: none;
          white-space: nowrap;
        }
        .items-table td {
          padding: 10px 8px;
          border-bottom: 1px solid #e2e8f0;
          border-right: 1px solid #e2e8f0;
        }
        .items-table td:last-child {
          border-right: none;
        }
        .items-table tr:nth-child(even) {
          background-color: #f8f9fa;
        }
        .items-table tr:hover {
          background-color: #edf2f7;
        }
        /* Mobile Responsive Content */
        .mobile-responsive-content {
          min-height: 100vh;
          background: white;
          padding: 0;
        }
        .add-job-card-page {
          padding: 16px;
          max-width: 800px;
          margin: 0 auto;
        }
        .input-group.same-line {
          display: flex;
          gap: 12px;
          align-items: center;
        }
        .input-group.same-line .search-input {
          flex: 1;
        }
        .input-group.same-line .search-btn {
          padding: 16px 20px;
          min-width: 80px;
          font-weight: 600;
        }
        .input-group.same-line .reset-btn {
          padding: 16px 20px;
          min-width: 60px;
          font-size: 18px;
          font-weight: bold;
        }
        .search-input {
          padding: 16px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-size: 16px;
          background: #f8f9fa;
          width: 100%;
        }
        .search-btn {
          background: #4299e1;
          color: white;
          border: none;
          border-radius: 12px;
          padding: 16px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .reset-btn {
          background: #dc2626;
          color: white;
          border: none;
          border-radius: 12px;
          padding: 16px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .customer-card,
        .form-card {
          background: white;
          border-radius: 16px;
          padding: 20px;
          margin-bottom: 16px;
          border: 1px solid #e2e8f0;
        }
        .card-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }
        .card-header i {
          color: #4299e1;
          font-size: 20px;
        }
        .card-header h3 {
          margin: 0;
          font-size: 18px;
          color: #2d3748;
        }
        .call-btn {
          background: #48bb78;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
          font-size: 12px;
          cursor: pointer;
        }
        .form-grid {
          display: grid;
        }
        .form-group {
          display: flex;
          flex-direction: column;
          text-align: left;
        }
        .description-group {
          position: relative;
        }
        .form-group.full-width {
          grid-column: 1 / -1;
        }
        .form-group label {
          font-weight: 600;
          color: #4a5568;
          font-size: 14px;
          margin-bottom: 4px;
        }
        .form-group label.required::after {
          content: " *";
          color: #e53e3e;
        }
        .form-group input,
        .form-group textarea {
          padding: 12px 10px;
          border: 2px solid #e2e8f0;
          border-radius: 8px;
          font-size: 16px;
        }
        .form-group input:focus,
        .form-group textarea:focus {
          outline: none;
          border-color: #4299e1;
        }
        .suggestion-loading {
          font-size: 12px;
          color: #718096;
          padding: 4px 0;
          text-align: left;
        }
        .suggestions-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 0 0 8px 8px;
          max-height: 200px;
          overflow-y: auto;
          z-index: 10;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        .suggestion-item {
          padding: 12px 16px;
          cursor: pointer;
          border-bottom: 1px solid #f1f1f1;
          font-size: 14px;
          color: #2d3748;
        }
        .suggestion-item:hover {
          background: #f7fafc;
        }
        .suggestion-item:last-child {
          border-bottom: none;
        }
        .add-item-btn {
          width: 100%;
          padding: 16px;
          background: #edf2f7;
          color: #4a5568;
          border: 2px dashed #cbd5e0;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          margin-bottom: 20px;
          transition: all 0.3s ease;
        }
        .add-item-btn:hover {
          background: #e2e8f0;
          border-color: #a0aec0;
        }
        .items-list {
          margin-bottom: 20px;
        }
        .items-list h4 {
          margin-bottom: 12px;
          color: #2d3748;
        }
        .edit-btn,
        .remove-btn {
          background: none;
          border: none;
          padding: 6px;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .edit-btn {
          color: #0352a1;
        }
        .remove-btn {
          color: #e53e3e;
        }
        .edit-btn:hover {
          background: #ebf8ff;
        }
        .remove-btn:hover {
          background: #fed7d7;
        }
        .summary-card {
          background: #f0fff4;
          border: 1px solid #9ae6b4;
          border-radius: 8px;
          padding: 16px;
          margin-bottom: 20px;
        }
        .summary-card h4 {
          margin: 0 0 12px 0;
          color: #22543d;
        }
        .summary-row {
          display: flex;
          justify-content: space-between;
          padding: 4px 0;
          color: #2d3748;
        }
        .summary-row.total {
          font-weight: 700;
          font-size: 18px;
          border-top: 1px solid #9ae6b4;
          padding-top: 8px;
          margin-top: 8px;
          color: #22543d;
        }
        .submit-btn {
          width: 100%;
          padding: 16px;
          background: #48bb78;
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          margin-top: 5px;
        }
        .submit-btn:disabled {
          background: #cbd5e0;
          cursor: not-allowed;
        }
        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 16px;
        }
        .modal-content {
          background: white;
          border-radius: 16px;
          width: 100%;
          max-width: 500px;
          max-height: 90vh;
          overflow-y: auto;
        }
        .delete-confirm-modal {
          max-width: 400px;
        }
        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
          border-bottom: 1px solid #e2e8f0;
        }
        .modal-header h3 {
          margin: 0;
          color: #2d3748;
        }
        .close-btn {
          background: none;
          border: none;
          font-size: 20px;
          color: #718096;
          cursor: pointer;
          padding: 4px;
        }
        .modal-body {
          padding: 5px 10px 0px 10px;
        }
        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
        .gst-options {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }
        .radio-label {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 5px;
          border: 2px solid #e2e8f0;
          border-radius: 6px;
          cursor: pointer;
          flex: 1;
          min-width: 80px;
          justify-content: center;
        }
        .radio-label input[type="radio"] {
          margin: 0;
        }
        .radio-label input[type="radio"]:checked + span {
          color: #4299e1;
          font-weight: 600;
        }
        .amount-display {
          background: #f7fafc;
          color: #2d3748;
          font-weight: 600;
        }
        .modal-footer {
          display: flex;
          gap: 5px;
          padding: 10px;
          border-top: 1px solid #e2e8f0;
        }
        .delete-actions {
          display: flex;
          gap: 12px;
          margin-top: 20px;
        }
        .btn-secondary {
          background: #e2e8f0;
          color: #4a5568;
          border: none;
          padding: 12px 20px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          flex: 1;
        }
        .btn-primary {
          background: #4299e1;
          color: white;
          border: none;
          padding: 12px 20px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          flex: 1;
        }
        .btn-danger {
          background: #dc2626;
          color: white;
          border: none;
          padding: 12px 20px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          flex: 1;
        }
        @media (max-width: 768px) {
          .add-job-card-page {
            padding: 12px;
          }
          .input-group.same-line {
            flex-direction: row;
          }
          .form-row {
            grid-template-columns: 1fr;
          }
          .gst-options {
            flex-direction: row;
          }
          .radio-label {
            min-width: 70px;
          }
          .modal-content {
            margin: 0;
            border-radius: 16px 16px;
            max-height: 80vh;
          }
          .items-table {
            font-size: 12px;
          }
          .items-table th,
          .items-table td {
            padding: 8px 6px;
          }
        }
        .home-icon {
          padding-left: 0px;
          padding-right: 0px;
        }
      `}</style>
    </div>
  );
};
export default AddJobCard;
